// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterToggleGroup } from '@/components/filter-toggle-group';
import { InventoryDimension } from '@/inventory/hooks';
import { INVENTORY_VIEW_OPTIONS } from '@/items/constants/inventory-view-options';
import { Stack, Typography } from '@mui/material';

interface Props {
  value: InventoryDimension;
  onChange: (value: InventoryDimension) => void;
}

export function InventoryViewSelector(props: Props) {
  return (
    <Stack direction="row" alignSelf="end" alignItems="center" spacing={1}>
      <Typography variant="subtitle2">View by</Typography>
      <FilterToggleGroup
        value={props.value}
        options={INVENTORY_VIEW_OPTIONS}
        onChange={props.onChange}
        ariaLabel="Inventory view dimension"
      />
    </Stack>
  );
}
